import React from 'react'
import moment from 'moment'

// components
import {
  CRow,
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'
import FormTextAreaInput from '../general-input-form/FormTextAreaInput'
import FormPrice from '../general-input-form/FormPrice'
import FormDatePicker from '../general-input-form/FormDatePicker'

const AppFormForOtherPage = ({
  values,
  handleChange,
  errors,
  onDateChange,
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormTextInput 
          id='project_name'
          name='project_name'
          colSize='6'
          inputLabel='Project Name'
          className='mb-3'
          placeholder='Enter project name...'
          value={values.project_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.project_name}
          invalid={errors.project_name}
        />
        <FormPrice
          id='project_value'
          name='project_value'
          colSize='3'
          inputLabel='Project Value'
          placeholder='Enter project value...'
          value={values.project_value}
          handlePriceInput={handleChange}
          feedbackInvalid={errors.project_value}
          invalid={errors.project_value}
        />
        <FormPrice
          id='project_tax_value'
          name='project_tax_value'
          colSize='3'
          inputLabel='Tax and other fees'
          placeholder='Enter project tax and other fees...'
          value={values.project_tax_value}
          handlePriceInput={handleChange}
          feedbackInvalid={errors.project_tax_value}
          invalid={errors.project_tax_value}
        />
        <FormTextAreaInput
          id='project_description'
          name='project_description'
          colSize='6'
          inputLabel='Project Description'
          className='mb-3'
          placeholder='Enter project description...'
          rows='5'
          value={values.project_description}
          handleTextAreaInput={handleChange}
          feedbackInvalid={errors.project_description}
          invalid={errors.project_description}
        />
        <FormDatePicker 
          id='project_start_date'
          name='project_start_date'
          colSize='3'
          inputLabel='Project Start Date'
          className='mb-3'
          handleOnDateChange={onDateChange}
          value={values.project_start_date}
          feedbackInvalid={errors.project_start_date}
          invalid={errors.project_start_date}
        />
        <FormDatePicker 
          id='project_end_date'
          name='project_end_date'
          colSize='3'
          inputLabel='Project End Date'
          className='mb-3'
          handleOnDateChange={onDateChange}
          value={values.project_end_date}
          feedbackInvalid={errors.project_end_date}
          invalid={errors.project_end_date}
          minDate={values.project_start_date ? moment(values.project_start_date).add(1, 'days') : null}
        />
      </CRow>
    </>
  )
}

export default AppFormForOtherPage